<template>
    <div class="imgRowWrapperFull message-wrapper">
        <div :style="!$kmsTheme ? null : $kmsTheme.styles.imgWrapperFull" v-for="picture in message.pictures" class="fullImage">
            <img :style="!$kmsTheme ? null : $kmsTheme.styles.imgFull" 
                 :class="[wideImage ? 'wideImage' : 'tallImage', 'rowImg']" 
                 :src="$http.defaults.baseURL + 'digitalNoticeBoard/picture?picture_id=' + picture.noticePictureId + '&type=' + picture.type" />
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        data() {
            return {
            }
        },
        props: {
            message: {
            
            },
            wideImage: {

            }
        }
    }



</script>
<style>
    .imgRowWrapperFull {
        height: 100%;
    }

    .fullImage {
        height: 100%;
        text-align: center;
        display: flex;
    }

    .rowImg {
        max-height: 100%;
        max-width: 100%;
        object-fit: contain;
    }

    div.fullImage img {
        position: relative;
        top: 0;
        bottom: 0;
        margin: auto;
        left: 0;
    }

    
</style>
